// components/SuccessPopup/SuccessPopup.jsx
import React, { useCallback, useEffect, useState } from "react";
import styles from "./SuccessPopup.module.css";

/** Single target for all mobile */
const IOS_STORE_URL = "https://apps.apple.com/pk/app/fuel-clubs/id6753362541";

const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
const isAndroid = () => /Android/.test(navigator.userAgent);



export default function SuccessPopup({
  title,
  message,
}) {
  // Desktop -> do nothing. Mobile -> go to App Store page.
//   useEffect(() => {
//     if (!isMobile()) return;
//     const t = setTimeout(() => {
//       // use href to preserve history if needed; replace if you want no back
//       window.location.href = IOS_STORE_URL;
//     }, 200);
//     return () => clearTimeout(t);
//   }, []);
  const [width, setWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1280);
  const isMobile = width < 768;


  const goDashboard = useCallback(() => {
    try { window.location.replace("/dashboard"); }
    catch { window.location.href = "/dashboard"; }
  }, []);

  return (
    <div className={styles.backdrop} role="dialog" aria-modal="true">
      <div className={styles.modal}>
        <div className={styles.iconWrap}>
          <svg viewBox="0 0 24 24" className={styles.icon} aria-hidden="true">
            <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 
                     4.477 10 10-4.477 10-10 10Zm-1.05-6.35 6.3-6.3a1 
                     1 0 1 0-1.414-1.414l-5.593 5.592-2.121-2.12a1 
                     1 0 0 0-1.415 1.414l2.829 2.828a1 1 0 0 0 1.414 0Z" />
          </svg>
        </div>

        <h3 className={styles.title}>{title || "Successfully Paid"}</h3>
        <p className={styles.message}>{message || "Thank you"}</p>

        {/* Desktop users can continue to dashboard. Mobile users will have been redirected already. */}
        <button className={styles.primaryBtn} 
        onClick={() => {isMobile?window.open('https://apps.apple.com/us/app/fuelclubs/id6753362541'): goDashboard()}}
        >
         {isMobile?"Open mobile":"Continue to Dashboard"}
        </button>
      </div>
    </div>
  );
}
